import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EmojiObjectsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"emoji_objects"}/>
}
